import { Report1913Container } from "../../../containers/borrowSystem/Report/Report1913Container";

export function Report1913Page() {
    return (
        <Report1913Container />
    )
}